<template>
  <b-container class="mt-3" fluid>
    <b-row>
      <b-col md="9" xs="12">
        <b-row>
          <b-col md="6">
            <h3>Delivery</h3>
            <b-form-group>
              <b-form-checkbox-group
                id="delivery-permissions-checkbox-group"
                stacked
                v-model="fields"
              >
                <b-form-checkbox value="create_deliveries"
                  >Create</b-form-checkbox
                >
                <b-form-checkbox value="delete_deliveries"
                  >Delete</b-form-checkbox
                >
                <b-form-checkbox value="edit_deliveries">Edit</b-form-checkbox>
                <b-form-checkbox value="edit_delivery_meta"
                  >Edit Meta</b-form-checkbox
                >
                <b-form-checkbox value="run_deliveries">Run</b-form-checkbox>
                <b-form-checkbox value="view_deliveries">View</b-form-checkbox>
                <b-form-checkbox value="proctor_deliveries"
                  >Proctor</b-form-checkbox
                >
              </b-form-checkbox-group>
            </b-form-group>
            <h3>Exam</h3>
            <b-form-group>
              <b-form-checkbox-group
                id="exam-permissions-checkbox-group"
                stacked
                v-model="fields"
              >
                <b-form-checkbox value="edit_agreements"
                  >Edit Agreements</b-form-checkbox
                >
                <b-form-checkbox value="edit_exam_meta"
                  >Edit Meta</b-form-checkbox
                >
                <b-form-checkbox value="edit_exam_settings"
                  >Edit Settings</b-form-checkbox
                >                
                <b-form-checkbox value="edit_surveys"
                  >Edit Surveys</b-form-checkbox
                >
                <b-form-checkbox value="view_agreements"
                  >View Agreements</b-form-checkbox
                >
                <b-form-checkbox value="view_exam_settings"
                  >View Settings</b-form-checkbox
                >
                <b-form-checkbox value="view_surveys"
                  >View Surveys</b-form-checkbox
                >
              </b-form-checkbox-group>
            </b-form-group>
            <h3>Export</h3>
            <b-form-group>
              <b-form-checkbox-group
                id="export-permissions-checkbox-group"
                stacked
                v-model="fields"
              >
                <b-form-checkbox value="export_content"
                  >Content</b-form-checkbox
                >
                <b-form-checkbox value="export_data">Data</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col md="6" xs="12">
            <h3>Item</h3>
            <b-form-group>
              <b-form-checkbox-group
                id="item-permissions-checkbox-group"
                stacked
                v-model="fields"
              >
                <b-form-checkbox value="create_items">Create</b-form-checkbox>
                <b-form-checkbox value="delete_items">Delete</b-form-checkbox>
                <b-form-checkbox value="edit_items">Edit</b-form-checkbox>
                <b-form-checkbox value="edit_item_meta"
                  >Edit Meta</b-form-checkbox
                >
                <b-form-checkbox value="view_items">View</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <h3>Manage</h3>
            <b-form-group>
              <b-form-checkbox-group
                id="manage-permissions-checkbox-group"
                stacked
                v-model="fields"
              >
                <b-form-checkbox value="manage_examinees"
                  >Examinees</b-form-checkbox
                >
                <b-form-checkbox value="manage_forms">Forms</b-form-checkbox>
                <b-form-checkbox value="manage_integrations"
                  >Integrations</b-form-checkbox
                >
                <b-form-checkbox value="manage_translations">Translations</b-form-checkbox>
                <b-form-checkbox value="manage_users">Users</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <h3>Response</h3>
            <b-form-group>
              <b-form-checkbox-group
                id="response-permissions-checkbox-group"
                stacked
                v-model="fields"
              >
                <b-form-checkbox value="edit_responses">Edit</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="9" xs="12">
        <h3>API Security</h3>
        <b-form-group label="IP Address Security" label-for="ip-address-security">
          <b-form-select
            id="ip-address-security"
            v-model="apiSecurity.ip_security"
            :options="ipSecurityOptions"
          ></b-form-select>
        </b-form-group>
        <div v-if="apiSecurity.ip_security !== 'none'">
          <b-form-group label="IP Addresses, Ranges, or CIDR Blocks">
            <b-input-group
              class="mb-2"
              v-for="(entry, index) in apiSecurity.ip_entries"
              :key="index"
            >
              <b-form-input
                :class="invalidIpEntries.includes(index) ? 'invalid' : ''"
                placeholder="192.0.2.1, 192.0.2.1-192.0.2.10, or 2001:db8::/32"
                v-model="apiSecurity.ip_entries[index]"
                @blur="validateIpEntries"
              ></b-form-input>
              <template v-slot:append>
                <b-button variant="white" @click="removeIpEntry(index)">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </b-button>
              </template>
            </b-input-group>
            <b-button variant="white" @click="addIpEntry">Add IP Entry</b-button>
          </b-form-group>
        </div>
        <b-form-group label="API Credential Lifetime" label-for="api-credential-lifetime">
          <b-form-select
            id="api-credential-lifetime"
            v-model="apiSecurity.credential_lifetime"
            :options="credentialLifetimeOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { deepCopy } from '../../utils/misc.js'

export default {
  name: 'Permissions',
  created() {
    this.setFields()
  },
  props: {
    app: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fields: {},
      apiSecurity: {
        ip_security: 'none',
        ip_entries: [],
        credential_lifetime: 'none'
      },
      invalidIpEntries: [],
      ipSecurityOptions: [
        { value: 'none', text: 'None' },
        { value: 'allowed', text: 'Allowed IPs' },
        { value: 'blocked', text: 'Blocked IPs' }
      ],
      credentialLifetimeOptions: [
        { value: 'none', text: 'None' },
        { value: '60_days', text: '60 Days' },
        { value: '180_days', text: '180 Days' },
        { value: '1_year', text: '1 Year' }
      ]
    }
  },
  methods: {
    report() {
      this.validateIpEntries()
      const data = [...this.fields]
      this.$emit('report', data, 'permissions')
      this.$emit('report', { ...this.apiSecurity }, 'api_security', Boolean(this.invalidIpEntries.length))
    },
    setFields() {
      const {
        app_settings: { permissions, api_security }
      } = this.app
      this.fields = deepCopy(permissions)
      this.apiSecurity = { ...this.apiSecurity, ...deepCopy(api_security || {}) }
    },
    addIpEntry() {
      this.apiSecurity.ip_entries.push('')
    },
    removeIpEntry(index) {
      this.apiSecurity.ip_entries.splice(index, 1)
      this.validateIpEntries()
    },
    validateIpEntries() {
      this.invalidIpEntries = []
      if (this.apiSecurity.ip_security === 'none') return
      this.apiSecurity.ip_entries.forEach((entry, index) => {
        if (!this.isValidIpEntry(entry)) this.invalidIpEntries.push(index)
      })
    },
    isValidIpEntry(entry) {
      if (!entry || !entry.trim()) return false
      const ipv4Octet = '(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)'
      const ipv4 = `${ipv4Octet}(\\.${ipv4Octet}){3}`
      const ipv6 = '([0-9a-fA-F]{0,4}:){2,7}[0-9a-fA-F]{0,4}'
      const single = new RegExp(`^(${ipv4}|${ipv6})$`)
      const cidr = new RegExp(`^(${ipv4}|${ipv6})\\/(\\d|[1-9]\\d|1[0-1]\\d|12[0-8])$`)
      const range = new RegExp(`^(${ipv4}|${ipv6})\\s*-\\s*(${ipv4}|${ipv6})$`)
      return single.test(entry) || cidr.test(entry) || range.test(entry)
    }
  }
}
</script>

<style lang="scss" scoped>
.invalid {
  border-color: #d86a03;
  box-shadow: 0 0 2px #d86a03;
}
</style>
